










import Vue from 'vue';

export default Vue.extend({
  props: {
    src: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: 'sm',
    },
    width: String,
    height: String,
  },
});
